import SeoHeader from 'src/components/custom-header';
import { FirebaseLoginView } from 'src/sections/auth/firebase';
import { paths } from 'src/routes/paths';

export default function LoginPage() {
  return (
    <>
      <SeoHeader
        title="SimpleT: User Login"
        description="Log in to your Simple Translate account to access translation tools, monitor usage, and manage multi-language deployments inside Salesforce."
        url={paths.auth.firebase.login}
        pageType="WebPage"
        keywords="simpletranslate login,salesforce translation login,user sign in simpletranslate,translation dashboard access,simpletranslate authentication"
      />

      <FirebaseLoginView />
    </>
  );
}
